export const SPECIAL_FISH_TYPES = [
  {
    id: 'normal',
    name: '普通木魚',
    description: '基本款木魚，敲擊後帶來好運與平安',
    unlockCondition: null,
    className: '',
    color: '#bd7d48',
    emoji: null,
    useSvg: true,
    svgType: 'normal',
    order: 1
  },
  {
    id: 'golden',
    name: '黃金木魚',
    description: '散發財富光芒的木魚，敲擊後增加財運',
    unlockCondition: 'buddha', 
    className: 'mokugyo-golden',
    color: 'linear-gradient(135deg, #ffd700, #f9b662)',
    emoji: null,
    useSvg: true,
    svgType: 'golden',
    order: 2
  },
  {
    id: 'crystal',
    name: '水晶木魚',
    description: '清澈透明的水晶木魚，敲擊後淨化心靈',
    unlockCondition: 'combo_100',
    className: 'mokugyo-crystal',
    color: 'linear-gradient(135deg, #a8e6ff, #d4f2ff)',
    emoji: null,
    useSvg: true,
    svgType: 'crystal',
    order: 3
  },
  {
    id: 'jade',
    name: '翡翠木魚',
    description: '象徵和平與長壽的翡翠木魚',
    unlockCondition: 'type_master',
    className: 'mokugyo-jade',
    color: 'linear-gradient(135deg, #7ecea0, #b5e8c3)',
    emoji: null,
    useSvg: true,
    svgType: 'jade',
    order: 4
  },
  {
    id: 'ruby',
    name: '紅寶石木魚',
    description: '充滿熱情的紅寶石木魚，敲擊後增加活力',
    unlockCondition: 'speed_3',
    className: 'mokugyo-ruby',
    color: 'linear-gradient(135deg, #e57373, #ffcdd2)',
    emoji: null,
    useSvg: true,
    svgType: 'ruby',
    order: 5
  },
  {
    id: 'cat',
    name: '貓咪木魚',
    description: '萌萌的貓咪造型木魚，敲擊時發出喵喵聲',
    unlockCondition: 'cat_lover',
    className: 'mokugyo-cat',
    color: 'linear-gradient(135deg, #ffcbb3, #ffdfd3)',
    emoji: null,
    useSvg: true,
    svgType: 'cat',
    order: 6
  },
  {
    id: 'rainbow',
    name: '彩虹木魚',
    description: '絢爛多彩的彩虹木魚，敲擊後帶來幸福感',
    unlockCondition: 'rainbow_master',
    className: 'mokugyo-rainbow',
    color: 'linear-gradient(to right, #ff5757, #ffbd59, #88e079, #5ae7ff, #7c84ff, #cf6fea)',
    emoji: null,
    useSvg: true,
    svgType: 'rainbow',
    order: 7
  },
  {
    id: 'cosmic',
    name: '宇宙木魚',
    description: '蘊含無限宇宙能量的神秘木魚，代表您對修行的極致追求',
    unlockCondition: 'cosmic_collector',
    className: 'mokugyo-cosmic',
    color: 'linear-gradient(45deg, #673ab7, #3f51b5, #2196f3, #00bcd4)',
    emoji: null,
    useSvg: true,
    svgType: 'cosmic',
    order: 99
  }
];

// 類型特效配置 (與木魚外觀無關)
export const TYPE_EFFECTS = {
  merit: {
    name: '功德',
    icon: '🙏',
    color: '#d97706',
    particles: ['🙏', '✨', '⭐'],
    glowColor: 'rgba(217, 119, 6, 0.3)'
  },
  love: {
    name: '愛情',
    icon: '💖',
    color: '#ec4899',
    particles: ['💖', '💕', '💗', '❤️'],
    glowColor: 'rgba(236, 72, 153, 0.3)'
  },
  wealth: {
    name: '財富',
    icon: '💰',
    color: '#eab308',
    particles: ['💰', '💵', '💴', '🪙'],
    glowColor: 'rgba(234, 179, 8, 0.3)'
  },
  health: {
    name: '健康',
    icon: '🍃',
    color: '#10b981',
    particles: ['🍃', '🌿', '💚', '✨'],
    glowColor: 'rgba(16, 185, 129, 0.3)'
  }
};

export const SPECIAL_FISH_STYLES = SPECIAL_FISH_TYPES.reduce((acc, fish) => {
  acc[fish.id] = fish;
  return acc;
}, {});